import { AlertTriangle } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../../shadcn/ui/tooltip";

interface DataFreshnessWarningProps {
  hasNewTourDate: boolean;
  hasRecentContactList: boolean;
}

/**
 * Yellow exclamation warning icon with tooltip explaining data freshness delays.
 * Shows when a tour date or contact list was added in the last 60 minutes.
 */
export function DataFreshnessWarning({
  hasNewTourDate,
  hasRecentContactList,
}: DataFreshnessWarningProps) {
  if (!hasNewTourDate && !hasRecentContactList) return null;

  const lines: string[] = [];
  if (hasNewTourDate) {
    lines.push(
      "This date is new. Please allow ~1 hour for fan information to be reflected."
    );
  }
  if (hasRecentContactList) {
    lines.push(
      "An eligible contact list was just uploaded, please allow for ~1 hour for fan data to be updated."
    );
  }

  return (
    <TooltipProvider>
      <Tooltip delayDuration={200}>
        <TooltipTrigger asChild>
          <span className="inline-flex items-center gap-1 cursor-help">
            <AlertTriangle className="h-4 w-4 text-yellow-500" />
            <span className="text-xs font-medium text-yellow-600">
              Updating...
            </span>
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-xs text-xs" sideOffset={4}>
          {lines.map((line, i) => (
            <p key={i} className={i > 0 ? "mt-1" : undefined}>
              {line}
            </p>
          ))}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
